module.exports = __webpack_public_path__ + "static/media/silhouette.eb9d0601.jpg";